<div class="container">
  <app-search-input-field (queryChanged)="filterHandelspartner($event)"></app-search-input-field>
  <div>
    <table mat-table #table [dataSource]="handelspartnerView" matSort class="mat-elevation-z8">
      <caption class="d-none">
        Liste der Händler
      </caption>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header="name" *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let h" (click)="openUserModal(h)" style="cursor: pointer">
          <div class="mnetUser">
            <i class="fas fa-user-edit"></i>
            {{ h.firstName }} {{ h.lastName }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="mnetId">
        <th mat-header-cell mat-sort-header="mnetId" *matHeaderCellDef>MNET-ID</th>
        <td mat-cell *matCellDef="let h">{{ h.mnetId }}</td>
      </ng-container>
      <ng-container matColumnDef="companyName">
        <th mat-header-cell mat-sort-header="companyName" *matHeaderCellDef>Firma</th>
        <td mat-cell *matCellDef="let h">{{ h.companyName }}</td>
      </ng-container>
      <ng-container matColumnDef="permissions">
        <th mat-header-cell mat-sort-header="permissions" *matHeaderCellDef>Darf an Abstimmung teilnehmen</th>
        <td mat-cell *matCellDef="let h">
          <markant-switch [checked]="hasVotingRight(h)" (checkedChange)="toggleVotingRight(h, $event)" color="primary"></markant-switch>
        </td>
      </ng-container>
      <ng-container matColumnDef="slug">
        <th mat-header-cell mat-sort-header="companySlug" *matHeaderCellDef>
          Kachelzuordnung <br />
          <mat-icon style="cursor: pointer; margin-left: 0.25rem" (click)="toggleSlugEditable($event)" alt="Bearbeiten"> edit </mat-icon>
        </th>
        <td mat-cell *matCellDef="let h">
          <markant-select (valueChange)="setSlug(h, $event)" [disabled]="!slugEditable" class="markant-select">
            <markant-select-option value="{{ null }}" [attr.selected]="!h.companySlug ? true : null"> - </markant-select-option>
            <markant-select-option *ngFor="let s of allSlugs" [value]="s" [attr.selected]="s === h.companySlug ? true : null"> {{ s }} </markant-select-option>
          </markant-select>
        </td>
      </ng-container>
    </table>
    <mat-paginator [pageSizeOptions]="[50]" showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>
  </div>
</div>
<app-edit-user *ngIf="this.selectedUser" (closeEvent)="closeDialog()" [form]="this.selectedUser"></app-edit-user>
